import { usePostHogContext } from '../context/posthog';

export function usePostHog<T extends string>() {
  const { posthog } = usePostHogContext();

  const track = (event: T, config: Record<string, any>) => {
    posthog?.trackEvent(event, config);
  };

  const identify = (userId?: string, userProperties?: Record<string, any>) => {
    posthog?.identifyUser(userId, userProperties);
  };

  const reset = () => {
    posthog?.resetUser();
  };

  const group = (
    groupType: string,
    groupKey: string,
    groupProperties?: Record<string, any>
  ) => {
    posthog?.group(groupType, groupKey, groupProperties);
  };

  const alias = (_alias: string) => {
    posthog?.alias(_alias);
  };

  return { track, identify, reset, group, alias };
}
